import {
  regex,
  req
} from 'vuelidate/lib/validators/common';
import {
  ssnRegex
} from '@/constants';

const format = regex('ssn', ssnRegex);

const zeros = (value) => {
  let zeroMatches = value.replace(ssnRegex, (match, a, b, c) => {
    return (a.toString() === '000' || b.toString() === '00' || c.toString() === '0000');
  });
  return !req(value) || zeroMatches !== 'true';
};

const sequence = (value) => {
  let sequenceMatches = value.replace(ssnRegex, (match, a, b, c) => {
    return (a.toString() === '123' && b.toString() === '45' && c.toString() === '6789');
  });
  return !req(value) || sequenceMatches !== 'true';
};

export {
  format,
  zeros,
  sequence,
};